"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSpotWorkerStore = createSpotWorkerStore;
const vue_1 = require("vue");
const api = __importStar(require("../api"));
function createSpotWorkerStore() {
    const state = (0, vue_1.reactive)({
        employees: {},
        pagination: {
            cursor: "",
            done: false,
        },
        fetching: false,
        mutating: false,
    });
    async function fetchNextPage(branchId) {
        if (state.fetching || state.pagination.done) {
            return;
        }
        try {
            state.fetching = true;
            const res = await api.getEmployeeList(branchId, state.pagination.cursor);
            res.data.forEach((worker) => {
                state.employees[worker.id] = worker;
            });
            state.pagination.cursor = res.pagination.cursor;
            state.pagination.done = res.pagination.done;
        }
        catch (err) {
            throw new Error(`Failed to get employees. Error: ${err}`);
        }
        finally {
            state.fetching = false;
        }
    }
    async function refresh(branchId) {
        state.employees = {};
        resetPagination();
        await fetchNextPage(branchId);
    }
    async function fetchWorkers(ids, branchId) {
        const uniqueIds = [...new Set(ids.filter((id) => id > 0))];
        const pageSize = 100;
        if (!uniqueIds.length || state.fetching) {
            return;
        }
        try {
            state.fetching = true;
            for (let index = 0; index < uniqueIds.length; index += pageSize) {
                const pageIds = uniqueIds.slice(index, index + pageSize);
                const res = await api.getEmployeesByIds(branchId, pageIds);
                res.data.forEach((worker) => {
                    state.employees[worker.id] = worker;
                });
            }
        }
        catch (err) {
            throw new Error(`Failed to get employees. Error: ${err}`);
        }
        finally {
            state.fetching = false;
        }
    }
    async function fetchWorker(id) {
        let worker = state.employees[id];
        if (!worker) {
            worker = await api.getEmployee(id);
            state.employees[id] = worker;
        }
        return worker;
    }
    async function createEmployee(payload) {
        if (state.mutating) {
            return;
        }
        try {
            state.mutating = true;
            const worker = await api.createEmployee(payload);
            state.employees[worker.id] = worker;
            return worker;
        }
        catch (err) {
            throw new Error(`Failed to create employee. Error: ${err}`);
        }
        finally {
            state.mutating = false;
        }
    }
    async function updateEmployee(payload) {
        if (state.mutating) {
            return;
        }
        try {
            state.mutating = true;
            const worker = await api.updateEmployee(payload);
            state.employees[worker.id] = worker;
            return worker;
        }
        catch (err) {
            throw new Error(`Failed to update employee. Error: ${err}`);
        }
        finally {
            state.mutating = false;
        }
    }
    async function deleteEmployeeFromBranch(payload) {
        if (state.mutating) {
            return;
        }
        try {
            state.mutating = true;
            await api.updateEmployeeBranches(payload);
            delete state.employees[payload.id];
        }
        catch (err) {
            throw new Error(`Failed to delete employee. Error: ${err}`);
        }
        finally {
            state.mutating = false;
        }
    }
    function getWorker(id) {
        return state.employees[id];
    }
    function resetPagination() {
        state.pagination.cursor = "";
        state.pagination.done = false;
    }
    function clear() {
        state.employees = {};
        resetPagination();
        state.fetching = false;
        state.mutating = false;
    }
    return {
        state,
        fetchNextPage,
        refresh,
        fetchWorkers,
        fetchWorker,
        getWorker,
        createEmployee,
        updateEmployee,
        deleteEmployeeFromBranch,
        resetPagination,
        clear,
    };
}
